<script>
  import { _, lget, locale } from "./i18n.js";
  import { onMount, onDestroy } from "svelte";
  import {
    f7,
    Page,
    Button,
    List,
    ListItem,
    ListInput,
    Icon,
    Sheet,
    Toolbar,
    PageContent,
    Block,
    BlockTitle,
    BlockHeader,
    Link,
    Toggle,
    Badge,
    Searchbar
  } from "framework7-svelte";
  import { getProfile } from "./UserService.js";
  import { getCartDoc } from "./CartService.js";
  import {
    firebase,
    getSecuredFirestore,
    getStorage,
    getCachedFirst
  } from "./Firestore.js";
  import {
    createOrder,
    createOrderNotificationMessage
  } from "./OrderService.js";
  import { generatePromptPayQRCode } from "./PromptPayQRCode.js";
  import CustomFileInput from "./CustomFileInput.svelte";
  import { sendLineNotifyMessage } from "./LineNotify.js";
  import { createTimeSlots } from "./DeliveryDateTime.js";
  import {
    formatAddress,
    getStaticDeliveryLocationImage,
    sendDeliveryRequest,
    COMPACT
  } from "./AddressService.js";
  import { checkImage, b64toBlob, showErrorNotifyDialog } from "./Utils.js";
  import moment from "moment";

  const IMAGE_SIZE = 300;
  export let f7router;
  let valid;
  let name;
  let addressRef = undefined;
  let addressData = undefined;
  let addresses = undefined;
  let termsChecked = false;
  let deliveryDate;
  let deliveryTime;
  let deliveryPrice;
  let cartDoc;
  let items = [];
  let totalAmount = 0;
  let paymentMethod = "cash";
  let paymentSlipFilename;
  let paymentSlip;
  let cartSnapshotListener;
  let addressSnapshotListener;
  let addressesSnapshotListener;
  let admin;
  let test = false;
  let userRef = undefined;
  let overwrittenUserRef = undefined;
  let qrcodeImageUrl;

  $: valid =
    name &&
    name.length > 0 &&
    addressRef &&
    deliveryDate &&
    deliveryTime &&
    items.length > 0 &&
    termsChecked;

  $: validPayment =
    valid &&
    (((paymentMethod === "promptPay" || paymentMethod === "bankTransfer") &&
      paymentSlip) ||
      paymentMethod === "cash");

  onMount(async () => {
    getProfile().then(function(profile) {
      name = profile.name;
      admin = profile.admin;

      getCartDoc(profile.userId).then(function(doc) {
        cartSnapshotListener = doc.onSnapshot(async function(c) {
          cartDoc = doc;
          let i = c.get("items");
          userRef = c.get("userRef");
          overwrittenUserRef = c.get("overwrittenUserRef");

          (overwrittenUserRef || userRef).get().then(function(user) {
            name = user.get("name") || c.get("name") || name;
          });

          addressRef = c.get("addressRef");

          // remove existing listener
          if (addressSnapshotListener) {
            addressSnapshotListener();
          }
          if (addressRef != null) {
            addressSnapshotListener = addressRef.onSnapshot(function(doc) {
              if (doc.exists) {
                addressData = { ...{ id: doc.id }, ...doc.data() };
              } else {
                addressData = null;
              }
            });
          } else {
            addressData = null;
          }

          test = c.get("test");
          totalAmount = 0;

          // resolve all product refs
          const forLoop = async _ => {
            for (let index = 0; index < i.length; index++) {
              const item = i[index];
              let product = await getCachedFirst(item.productRef);
              item.product = product;
              totalAmount += product.get("price") * item.amount;
            }
          };
          await forLoop();

          deliveryDate = c.get("deliveryDate")
            ? moment(c.get("deliveryDate").toDate()).format("Do MMMM YYYY")
            : moment().format("Do MMMM YYYY");
          deliveryTime = c.get("deliveryTime");
          initDeliveryDatePicker(deliveryDate, deliveryTime);
          deliveryPrice = c.get("deliveryPrice");
          totalAmount += deliveryPrice;

          items = i;

          let currentUserId = overwrittenUserRef
            ? overwrittenUserRef.id
            : profile.userId;

          getSecuredFirestore().then(function(firestore) {
            addressesSnapshotListener = firestore
              .collection("users/" + currentUserId + "/addresses")
              .orderBy("primary", "desc")
              .onSnapshot(async function(snapshot) {
                let a = [];
                let addressMatch = false;
                snapshot.forEach(function(doc) {
                  a.push({ ...{ id: doc.id }, ...doc.data() });

                  if (addressRef && addressRef.id === doc.id) {
                    addressMatch = true;
                  }
                });
                addresses = a;

                // if current address does not match, select primary from list
                if (!addressMatch) {
                  if (addresses.length > 0) {
                    let address = addresses.find(item => item.primary === true);
                    address = address || addresses[0];
                    addressRef = firestore
                      .collection("address/" + currentUserId + "/addresses")
                      .doc(address.id);
                    addressData = address;
                  } else {
                    addressRef = null;
                    addressData = null;
                  }
                }
              });
          });
        });
      });
    });
  });

  var deliveryDatePicker;
  function initDeliveryDatePicker(initialDate, initialTime) {
    if (!deliveryDatePicker) {
      const deliveryDates = [];
      const deliveryTimes = [];
      let today = moment();
      for (let i = 0; i < 10; i++) {
        let timeslots = createTimeSlots(today);
        if (timeslots.length > 0) {
          let dateValue = today.format("Do MMMM YYYY");
          deliveryDates.push(dateValue);
          deliveryTimes[dateValue] = timeslots;
        }

        today
          .add(1, "days")
          .hours(0)
          .minutes(0);
      }

      if (deliveryDates.indexOf(initialDate) == -1) {
        initialDate = deliveryDates[0];
      }

      deliveryDatePicker = f7.picker.create({
        inputEl: "#deliveryDatePicker",
        openIn: "sheet",
        routableModals: false,
        value: [initialDate, initialTime],
        formatValue(values) {
          return values[0] + ", " + values[1];
        },
        on: {
          close: updateDeliveryDateTime
        },
        cols: [
          {
            textAlign: "left",
            values: deliveryDates,
            onChange(picker, date) {
              let col = picker.cols[1];
              if (col.replaceValues) {
                let newTimes = deliveryTimes[date];
                let lastDeliveryTime = deliveryTime;
                col.replaceValues(newTimes);
                col.setValue(
                  newTimes.indexOf(lastDeliveryTime) != -1
                    ? lastDeliveryTime
                    : newTimes[0]
                );
              }
              deliveryDate = date;
            }
          },
          {
            values: deliveryTimes[initialDate],
            onChange(picker, time) {
              deliveryTime = time;
            }
          }
        ]
      });
    }
  }

  function updateName(value) {
    if (value !== name) {
      name = value;
      cartDoc.update({ name: name });
    }
  }

  function updateAddressRef(value) {
    addressRef = value;
    cartDoc.update({ addressRef: addressRef });
  }

  function updateDeliveryDateTime() {
    cartDoc.update({
      deliveryDate: firebase.firestore.Timestamp.fromDate(
        moment(deliveryDate, "Do MMMM YYYY").toDate()
      ),
      deliveryTime: deliveryTime
    });
  }

  function updateTest(value) {
    if (value !== test) {
      test = value;
      cartDoc.update({ test: test });
    }
  }

  onDestroy(async () => {
    cartSnapshotListener && cartSnapshotListener();
    addressSnapshotListener && addressSnapshotListener();
    addressesSnapshotListener && addressesSnapshotListener();
  });

  function confirmOrder() {
    let dialog = f7.dialog.progress($_("orderNew.creatingOrder"));

    let safeItems = items.map(function(item) {
      let copy = { ...item };
      delete copy.productRef;
      let product = copy.product;
      let safeProduct = {};
      safeProduct.title = product.get("title");
      safeProduct.price = product.get("price");
      copy.product = safeProduct;
      return copy;
    });

    let address = formatAddress({
      ...addressData,
      ...{ mode: COMPACT }
    });
    let location = addressData.location;

    createOrder(
      test,
      name,
      address,
      location,
      safeItems,
      paymentMethod,
      moment(deliveryDate, "Do MMMM YYYY").toDate(),
      deliveryTime,
      deliveryPrice,
      overwrittenUserRef || userRef,
      paymentSlip,
      cartDoc
    )
      .then(function(result) {
        let orderId = result.orderId;
        let orderData = result.orderData;

        // send notification to LINE delivery group
        let message = createOrderNotificationMessage(
          orderId,
          orderData,
          $locale
        );

        sendLineNotifyMessage({
          message: message,
          image: orderData.paymentSlipUrl
        }).catch(function(e) {
          console.log(e);
        });

        // send an order receipt to the LINE official account on behalf of the customer
        try {
          liff.sendMessages([
            {
              type: "text",
              text:
                $_("orderNew.success") +
                ": " +
                orderId +
                "\n" +
                process.env.LIFF_SERVER_URL +
                "/Order/" +
                orderId
            }
          ]);
        } catch (e) {
          console.log(e);
        }

        dialog.close();
        f7.sheet.close(".order-sheet");
        f7router.navigate("/Order/Success/" + orderId, {
          history: false,
          pushState: false
        });
      })
      .catch(function(e) {
        dialog.close();
        console.log(e);
        showErrorNotifyDialog(
          $_("orderNew.title"),
          $_("orderNew.error"),
          name,
          e
        );
      });
  }

  function switchPaymentMethod(mode) {
    paymentMethod = mode;
    switch (mode) {
      case "cash":
        break;
      case "promptPay":
        generateQRCode();
        break;
      case "bankTransfer":
        break;
    }
  }

  function generateQRCode() {
    let totalAmount =
      items
        .map(i => i.product.get("price") * i.amount)
        .reduce((a, b) => a + b, 0) + deliveryPrice;

    generatePromptPayQRCode(totalAmount).then(function(png) {
      getStorage().then(async function(storage) {
        var storageRef = storage.ref();
        let userId = await getCurrentUserId();
        let qrcodeFilename = userId + "-qrcode.png";
        var file = storageRef.child(qrcodeFilename);
        let blob = b64toBlob(
          png.replace("data:image/png;base64,", ""),
          "image/png"
        );

        file
          .put(blob)
          .then(function(snapshot) {
            return snapshot.ref.getDownloadURL();
          })
          .then(function(url) {
            qrcodeImageUrl = url;
          });
      });
    });
  }

  function uploadePaymentSlip(e) {
    let file = e.detail[0];
    paymentSlipFilename = file.name;
    var fr = new FileReader();
    fr.onload = function(e) {
      paymentSlip = e.target.result;
    };
    fr.readAsDataURL(file);
  }

  function removePaymentSlip() {
    paymentSlipFilename = null;
    paymentSlip = null;
    let els = document.getElementsByClassName("inputfile");
    [].forEach.call(els, function(el) {
      el.value = "";
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      el.dispatchEvent(evt);
    });
  }

  function openExternalQrCodeUrl() {
    liff.openWindow({
      url: qrcodeImageUrl,
      external: true
    });
  }

  function copyBankAccount() {
    var copyText = document.getElementById("bankAccount");
    var textArea = document.createElement("textarea");
    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    f7.toast
      .create({
        text: $_("orderNew.payment.copyBankAccountNumber"),
        closeTimeout: 6000
      })
      .open();
  }

  function getAddressOptionLabel(address) {
    let label = formatAddress({
      building: address.building,
      moo: address.moo,
      street: address.street,
      subdistrict: address.subdistrict,
      district: address.district,
      province: address.province,
      country: address.country,
      zipcode: address.postalCode,
      mode: COMPACT
    });

    if (address.primary || !address.deliverable) {
      let postFixes = [];
      if (address.primary) {
        postFixes.push($_("orderNew.address.primaryPostfix"));
      }
      if (!address.deliverable) {
        postFixes.push($_("orderNew.address.undeliverablePostfix"));
      }
      label += " (" + postFixes.join(", ") + ")";
    }

    return label;
  }

  function getUsers() {
    return getSecuredFirestore().then(function(firestore) {
      return getCachedFirst(firestore.collection("users").orderBy("name")).then(
        function(querySnapshot) {
          const users = [];
          querySnapshot.forEach(doc => {
            users.push({
              id: doc.id,
              name: doc.get("name"),
              profilePhoto: doc.get("profilePhoto"),
              orderCount: doc.get("orderCount"),
              test: false
            });
          });
          return users;
        },
        function(err) {
          console.log(err);
          f7.dialog.alert($_("users.error"));
        }
      );
    });
  }

  function changeUser(user) {
    return getSecuredFirestore().then(function(firestore) {
      let userRef = firestore.collection("users").doc(user.id);
      cartDoc.update({ overwrittenUserRef: userRef });
    });
  }

  function removeOverwrittenUser() {
    cartDoc.update({
      overwrittenUserRef: firebase.firestore.FieldValue.delete()
    });
  }

  async function getCurrentUserId() {
    return overwrittenUserRef
      ? overwrittenUserRef.id
      : getProfile().then(profile => profile.userId);
  }
</script>

<style>
  :root {
    --f7-list-button-text-align: center;
  }
</style>

<div>
  <span style="display: none" class="hidden" />
  <BlockTitle medium style="display: flex; justify-content: space-between;">
    {$_('orderNew.title')}
  </BlockTitle>
  <List id="checkout-form" form inlineLabels noHairlines>
    {#if overwrittenUserRef}
      {#await overwrittenUserRef.get() then user}
        <ListItem
          title={user.get('name')}
          style="margin-top: 5px; margin-bottom: 5px"
          on:change={e => changeUser(user)}>
          <div slot="media">
            {#if user.get('profilePhoto')}
              {#await checkImage(user.get('profilePhoto')) then status}
                {#if status}
                  <img
                    style="max-width: 40px; border-radius: 50%; margin-right:
                    10px"
                    alt="User Profile"
                    src={user.get('profilePhoto')} />
                {:else}
                  <span
                    style="font-size: 2.5rem; color: rgb(0, 122, 255);
                    margin-right: 10px"
                    class="icon icon-profile" />
                {/if}
              {/await}
            {/if}
          </div>
          <div style="display: flex" slot="content">
            <Link on:click={e => removeOverwrittenUser()}>
              <span
                style="color: red; margin-right: 15px; font-size: 22px"
                class="icon icon-remove-user"
                title="Remove Custom User" />
            </Link>
            <Link sheetOpen=".switch-user-sheet">
              <span
                style="margin-right: 15px; font-size: 22px"
                class="icon icon-switch-user"
                title="Switch User" />
            </Link>
          </div>
        </ListItem>
      {/await}
    {:else if userRef}
      {#await userRef.get() then user}
        <ListInput
          type="text"
          value={name}
          onChange={e => updateName(e.target.value)}
          placeholder={$_('orderNew.name.placeholder')}
          required
          validate>
          <div slot="media">
            {#if user.get('profilePhoto')}
              {#await checkImage(user.get('profilePhoto')) then status}
                {#if status}
                  <img
                    style="max-width: 40px; border-radius: 50%; margin-right:
                    10px"
                    alt="User Profile"
                    src={user.get('profilePhoto')} />
                {:else}
                  <span
                    style="font-size: 2.5rem; color: rgb(0, 122, 255);
                    margin-right: 10px"
                    class="icon icon-profile" />
                {/if}
              {/await}
            {/if}
          </div>
          <div slot="content">
            {#if admin}
              <Link sheetOpen=".switch-user-sheet">
                <span
                  style="margin-right: 15px; font-size: 22px"
                  class="icon icon-switch-user" />
              </Link>
            {/if}
          </div>
        </ListInput>
      {/await}
    {/if}

    {#if addressRef !== undefined && addressData !== undefined && addresses !== undefined}
      {#if addresses.length > 0}
        <ListItem
          id="addressSmartSelect"
          smartSelect
          smartSelectParams={{ valueEl: '.hidden', sheetCloseLinkText: $_('base.done'), routableModals: false, renderItem: function(item, index) {
              let selected = addressRef ? item.value === addressRef.id : addresses.length === 1 ? true : item.selected;
              let disabled = item.disabled ? 'disabled' : '';
              let html = '<li class="">';
              html += '<label class="item-radio item-content">';
              let checked = selected ? ' checked' : '';
              html += '<input ' + disabled + ' type="radio" name="' + item.inputName + '" value="' + item.value + '"' + checked + '>';
              html += '<i class="' + disabled + ' icon icon-radio"></i>';
              html += '<div class="item-inner">';
              html += '<div class="' + disabled + ' item-title">' + item.text + '</div>';
              html += '<a onClick="window.dispatchEvent(new CustomEvent(\'closeSmartSelect\'))" href="/Address/' + (overwrittenUserRef ? overwrittenUserRef.id : userRef.id) + '/' + item.value + '"><span style="font-size: 1.2rem" class="icon icon-external"></span></a>';
              html += '</div>';
              html += '</label>';
              html += '</li>';
              return html;
            }, openIn: 'sheet', on: { closed: function(e) {
                let addressId = e.getValue();
                getCurrentUserId().then(function(userId) {
                  getSecuredFirestore().then(function(firestore) {
                    let addressRef = firestore.doc('users/' + userId + '/addresses/' + addressId);
                    updateAddressRef(addressRef);
                  });
                });
              } } }}>
          <div style="width: 100%">
            <div class="item-title item-label">{$_('orderNew.address')}</div>
            <div style="max-width: 100%; padding-left: 0px" class="item-after">
              {#if addressData != null}{getAddressOptionLabel(addressData)}{/if}
            </div>
            <select
              name="address"
              value={addressRef != null ? addressRef.id : ''}>
              {#each addresses as address}
                <option value={address.id}>
                  {getAddressOptionLabel(address)}
                </option>
              {/each}
            </select>
          </div>
        </ListItem>

        {#if addressRef != null && addressData && addressData.location}
          <li>
            <Link
              href="/Address/{overwrittenUserRef ? overwrittenUserRef.id : userRef.id}/{addressRef.id}">
              <img
                style="width: 100%;"
                alt="Delivery Location"
                src={getStaticDeliveryLocationImage({ lat: addressData.location.latitude, lng: addressData.location.longitude }, { width: 640, height: 300 })} />
            </Link>
          </li>
        {/if}

        <ListItem>
          <div style="width: 100%" class="item-title">
            {#if addressRef != null}
              <li>
                <Button
                  style="margin-top: 0px; margin: 10px; font-weight: bold"
                  color="blue"
                  small
                  round
                  outline
                  href="/Address/{overwrittenUserRef ? overwrittenUserRef.id : userRef.id}/{addressRef.id}">
                  {$_('orderNew.editAddress')}
                  <span
                    style="margin-left: 4px; vertical-align: text-top;"
                    class="icon icon-address" />
                </Button>
              </li>
            {/if}

            {#if addresses.length < 3}
              <Button
                style="margin-top: 0px; margin: 10px; font-weight: bold"
                color="green"
                small
                round
                fill
                href="/Address/{overwrittenUserRef ? overwrittenUserRef.id : userRef.id}/New">
                {$_('orderNew.addNewAddress')}
                <span
                  style="margin-left: 4px; vertical-align: text-top;"
                  class="icon icon-plus" />
              </Button>
            {/if}
          </div>
        </ListItem>
      {:else}
        <ListItem>
          <div style="width: 100%" class="item-title">
            <span>{$_('orderNew.address')}</span>
            <div class="item-text">{$_('orderNew.noAddresses')}</div>
            <Button
              style="margin-top: 0px; margin: 10px; font-weight: bold"
              color="green"
              small
              round
              fill
              href="/Address/{overwrittenUserRef ? overwrittenUserRef.id : userRef.id}/New">
              {$_('orderNew.addNewAddress')}
              <span
                style="margin-left: 4px; vertical-align: text-top;"
                class="icon icon-plus" />
            </Button>
          </div>
        </ListItem>
      {/if}
    {/if}

    {#if addressData && !addressData.deliverable}
      <ListItem style="background-color: #ff00000a">
        <div style="width: 100%" class="item-title">
          <span style="color: red; font-weight: bold">
            {$_('orderNew.address.undeliverable.title')}
          </span>
          <div class="item-text">
            {$_('orderNew.address.undeliverable.description')}
          </div>
          <Button
            style="margin: 20px; margin-left: 5px; margin-right: 5px"
            color="red"
            small
            fill
            round
            on:click={function() {
              let message = formatAddress({
                ...addressData,
                ...{ mode: COMPACT }
              });
              if (addressData.location) {
                message += '\n' + 'https://www.google.com/maps/search/' + addressData.location.latitude + ',' + addressData.location.longitude;
              }
              sendDeliveryRequest(message);
            }}>
            {$_('orderNew.button.deliveryRequest')}
            <Icon style="margin-left: 4px; color: white;" icon="icon-line" />
          </Button>
        </div>
      </ListItem>
    {/if}

    <ListInput
      label={$_('orderNew.deliveryDate')}
      type="text"
      placeholder={$_('orderNew.deliveryDate.placeHolder')}
      readonly
      inputId="deliveryDatePicker" />

    {#if admin}
      <ListItem>
        <div class="item-title">
          {$_('orderNew.testOrder.title')}
          <div class="item-subtitle">
            <span>
              {@html test ? '<span style="color: rgb(0, 122, 255);">' + $_('orderNew.testOrder.on') + '</span>' : $_('orderNew.testOrder.off')}
            </span>
          </div>
        </div>
        <Toggle checked={test} onChange={e => updateTest(e.target.checked)} />
      </ListItem>
    {/if}

    <ListItem
      checkbox
      checked={termsChecked}
      onChange={e => (termsChecked = e.target.checked)}
      required={true}
      validate
      title={$_('orderNew.agreement')}>
      <div class="item-after">
        <Link href="/Terms">
          <Icon
            size="22px"
            href="/Terms"
            color="blue"
            icon="icon icon-external" />
        </Link>
      </div>
    </ListItem>
  </List>

  <Button
    disabled={!valid}
    style="margin: 20px;"
    fill
    round
    sheetOpen=".order-sheet">
    {$_('orderNew.button.makePayment')}
    <Icon
      style="margin-left: 5px; vertical-align: text-top;"
      icon="icon-credit-card" />
  </Button>

  <List>
    {#if items.length == 0}
      <ListItem>
        <div style="color: red; font-weight: bold" class="item-title">
          {$_('orderNew.noItems')}
        </div>
        <Button href="/Products/" color="green" small outline round>
          {$_('orderNew.addProducts')}
        </Button>
      </ListItem>
    {:else}
      <ListItem link="/Cart" title={$_('orderNew.numberOfItems')}>
        <div class="item-after">
          <Badge color="green">{items.length}</Badge>
        </div>
      </ListItem>
    {/if}
  </List>

  <Sheet
    class="order-sheet"
    style="height: 100%; --f7-sheet-bg-color: #fff"
    push={true}>
    <Toolbar>
      <div class="left" />
      <div class="right">
        <Link sheetClose>{$_('base.close')}</Link>
      </div>
    </Toolbar>
    <PageContent>
      <BlockTitle medium>{$_('orderNew.payment.orderTitle')}</BlockTitle>
      <List noHairlines>
        {#each items as item}
          <ListItem
            title={item.amount + 'x ' + lget(item.product, 'title', $locale)}>
            <b slot="after">
              {(item.product.get('price') * item.amount).toLocaleString(
                $locale,
                { minimumFractionDigits: 2 }
              )} THB
            </b>
          </ListItem>
        {/each}
        {#if deliveryPrice}
          <ListItem title={$_('orderNew.payment.deliveryFee')}>
            <b slot="after">
              {deliveryPrice.toLocaleString($locale, {
                minimumFractionDigits: 2
              })} THB
            </b>
          </ListItem>
        {/if}
        <ListItem class="bold" title={$_('orderNew.payment.totalAmount')}>
          <b slot="after" class="text-color-blue">
            <b>
              {totalAmount.toLocaleString($locale, {
                minimumFractionDigits: 2
              })} THB
            </b>
          </b>
        </ListItem>
      </List>
      <BlockTitle medium class="margin-top">
        {$_('orderNew.payment.paymentTitle')}
      </BlockTitle>
      <BlockHeader>{$_('orderNew.payment.paymentMethod')}:</BlockHeader>
      <List>
        <ListItem
          radio
          radioIcon="start"
          title={$_('orderNew.payment.payInCash')}
          value="cash"
          name="demo-radio-start"
          checked
          on:click={e => switchPaymentMethod('cash')} />
        <ListItem
          radio
          radioIcon="start"
          title={$_('orderNew.payment.payByBankTransfer')}
          value="bank"
          name="demo-radio-start"
          on:click={e => switchPaymentMethod('bankTransfer')} />
        <ListItem
          radio
          radioIcon="start"
          title={$_('orderNew.payment.payWithPromptPayQRCode')}
          value="bank"
          name="demo-radio-start"
          on:click={e => switchPaymentMethod('promptPay')} />
      </List>
      {#if paymentMethod === 'promptPay'}
        <div
          style="display: flex; flex-direction: column; align-items: center;">
          <Button on:click={generateQRCode}>
            {$_('orderNew.payment.regenerateQRCode')}
          </Button>
          <div style="max-width: {IMAGE_SIZE}px; width: 100%">
            <img style="width: 100%" alt="QR-Code" src={qrcodeImageUrl} />
          </div>

          <ol>
            <li>
              <Link alt="Download QR-Code" on:click={openExternalQrCodeUrl}>
                {$_('orderNew.payment.payWithPromptPayQRCode.step1')}
              </Link>
            </li>
            <li>{$_('orderNew.payment.payWithPromptPayQRCode.step2')}</li>
            <li>{$_('orderNew.payment.payWithPromptPayQRCode.step3')}</li>
            <li>{$_('orderNew.payment.payWithPromptPayQRCode.step4')}</li>
            <li>
              {$_('orderNew.payment.payWithPromptPayQRCode.step5')}
              <div style="margin-top: 5px">
                <CustomFileInput
                  class="paymentSlip"
                  accept="image/jpeg, image/png"
                  on:input={uploadePaymentSlip} />
              </div>
            </li>
          </ol>

          {#if paymentSlip}
            <img
              style="border: 1px dashed lightgray; padding: 5px; max-width: {IMAGE_SIZE}px;
              margin-top: 10px"
              alt="Payment Slip"
              src={paymentSlip} />
            <Link
              style="margin-top: 5px"
              color="red"
              on:click={removePaymentSlip}>
              {$_('orderNew.payment.removePaymentSlip')}
            </Link>
          {/if}
        </div>
      {:else if paymentMethod === 'bankTransfer'}
        <div
          style="display: flex; flex-direction: column; align-items: center;">
          <img
            style="max-width: {IMAGE_SIZE}px; margin-top: 10px"
            alt="Bank Account"
            src="https://lh3.googleusercontent.com/riUO0R5pRjT3Dwv6O8Jg9L3UzmAtHwLjbxg7xMaTnGzOF1_eCbgIfM4hc8bsAUr9SuCI4nvvmAwpB0i-Ed65nGWnrYlsWrmp8qKham4kbQCOcr95ZBvZamHFIUB90G1vz0P5zRxmDzyHU9yP5nNp4kMlfMfjwp1GFWBHCrrL9Sfpf2lLuy60kHYkC0LO_MvfrbdbKO00NCMTzyjaSniuN0NpPspAeqyf-y0eNuXFQTBVABrGs39_NPr5Y2uePS3DMphLNPlyRgu3dJGJK4QP2tjjYXSAuoo7j3X5lX-m1TJHBTop46I6olIijbuOdc1efSEqkDbXUvQe8vl9J3MMxJ2iJoEGprunhLyi8gf2iksryH9PQt1t78gN9pbUKd-_vwxXMzyQODJyBZ2RoFVBMIebPebqg4HMeG4rgX24NsjxKzpoEkst5b6AQLrSdUAT5TQRVYDm64QxzXftg-UnaFrMyzoBrtEQAXA3X1uhYHYbzX2KZ0WM_1CWzvoWeejhr1-PDIUjxM3-LRBUDI5j3-O3DbHux8y6NQYn-44mU3zoSJExl1HrwpG5SbdqtvwzArFI1kw3p_eT5k-RlY_e4awxPng8lclp5Wva-BE6LUpTNs250dmYf-dCkI41ofBZvzhNLthKzpscrRhjL0Zei2yBpyZtND0iTa-T8cOOzRWClOITatpynWuHb5-KY7qwKW4ZjvZK89HgRlpnm2yHAEHx0S5t9PO4RRqgo7IE1lCfN0gR6W6lLw=s800" />

          <ol style="margin-bottom: 0px">
            <li>
              {$_('orderNew.payment.payByBankTransfer.step1')}:
              <div>
                <div
                  style="margin-top: 6px; margin-bottom: 6px; font-weight: bold;
                  font-size: 1.2rem">
                  นางสาว กิตติยา กาสังข์:
                  <span id="bankAccount">572-279403-2</span>
                </div>
                <Button
                  style="margin-bottom: 5px; margin-bottom: 10px"
                  small
                  outline
                  on:click={copyBankAccount}>
                  {$_('orderNew.button.payByBankTransfer.copyToClipboard')}
                  <span style="margin-left: 6px;" class="icon icon-copy" />
                </Button>
              </div>
            </li>
            <li>
              {$_('orderNew.payment.payByBankTransfer.step2')}
              <div style="margin-top: 5px">
                <CustomFileInput
                  class="paymentSlip"
                  accept="image/jpeg, image/png"
                  on:input={uploadePaymentSlip} />
              </div>
            </li>
          </ol>

          {#if paymentSlip}
            <img
              style="border: 1px dashed lightgray; padding: 5px; max-width: {IMAGE_SIZE}px;"
              alt="Payment Slip"
              src={paymentSlip} />
            <Link
              style="margin-top: 5px"
              color="red"
              on:click={removePaymentSlip}>
              {$_('orderNew.payment.removePaymentSlip')}
            </Link>
          {/if}
        </div>
      {/if}

      <div
        style="margin-top: 20px; margin-bottom: 20px"
        class="padding-horizontal padding-bottom">
        <Button disabled={!validPayment} fill round on:click={confirmOrder}>
          {$_('orderNew.payment.confirmOrder')}
          <Icon
            style="margin-left: 5px; vertical-align: text-top;"
            icon="icon-check" />
        </Button>
      </div>
    </PageContent>
  </Sheet>

  {#if admin}
    <Sheet
      class="switch-user-sheet"
      style="height: 100%; --f7-sheet-bg-color: #fff"
      push={true}>
      <PageContent>
        <BlockTitle medium>Select User</BlockTitle>

        <Searchbar searchContainer=".search-list" disableButton={false} />

        <List class="searchbar-not-found">
          <ListItem title="Nothing found" />
        </List>
        <List class="search-list">
          {#await getUsers() then users}
            {#each users as user}
              <ListItem
                radio
                title="{user.name} ({user.orderCount})"
                style="margin-top: 5px; margin-bottom: 5px"
                checked={overwrittenUserRef && user.id === overwrittenUserRef.id}
                on:change={e => changeUser(user)}>
                <span slot="content-end">
                  {#if user.profilePhoto}
                    {#await checkImage(user.profilePhoto) then status}
                      {#if status}
                        <img
                          style="max-width: 40px; border-radius: 50%;
                          margin-right: 10px"
                          alt="User Profile"
                          src={user.profilePhoto} />
                      {:else}
                        <span
                          style="font-size: 2.5rem; color: rgb(0, 122, 255);
                          margin-right: 10px"
                          class="icon icon-profile" />
                      {/if}
                    {/await}
                  {:else if users}
                    <span
                      style="font-size: 2.5rem; color: rgb(0, 122, 255);
                      margin-right: 10px"
                      class="icon icon-profile" />
                  {/if}
                </span>
              </ListItem>
            {/each}
          {/await}
        </List>
      </PageContent>
      <Toolbar position="bottom">
        <div class="left" />
        <div class="right">
          <Link sheetClose>{$_('base.close')}</Link>
        </div>
      </Toolbar>
    </Sheet>
  {/if}
</div>

<svelte:window
  on:closeSmartSelect={function() {
    f7.smartSelect.close('#addressSmartSelect');
  }} />
